import gql from 'graphql-tag';
import { messageFragment } from '../fragments/message.fragment';
import { pageInfoFragment } from '../fragments/page-info.fragment';

export const threadMessagesQuery = gql`
  query threadMessages($threadID: ID!, $limit: Int, $after: ID) {
    threadMessages(threadID: $threadID, limit: $limit, after: $after) {
      data {
        ...messageFragment
      }

      pageInfo {
        ...pageInfoFragment
      }
    }
  }
  ${messageFragment}
  ${pageInfoFragment}
`;
